import React from 'react';
import PageWrapper from '../components/PageWrapper';

const Datenschutz = () => {
  return (
    <PageWrapper className="py-16 bg-white">
      <div className="max-w-3xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-blue-900 mb-8">Datenschutzerklärung</h1>
        <div className="prose prose-slate max-w-none text-slate-600 space-y-6">
          
          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">1. Datenschutz auf einen Blick</h2>
            <h3 className="text-lg font-bold text-slate-700 mb-2">Allgemeine Hinweise</h3>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">2. Verantwortlicher</h2>
            <p>Verantwortlich für die Datenverarbeitung auf dieser Website:</p>
            <p>
              Nordblick Recruiting<br />
              Isaq Amini<br />
              Barmbeker Str. 9a<br />
              22303 Hamburg<br />
              Deutschland
            </p>
            <p>
              Telefon: 0160 5074 395<br />
              E-Mail: info@nordblick-recruiting.de
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">3. Hosting</h2>
            <p>Diese Website wird bei IONOS gehostet.</p>
            <p>
              Der Hostinganbieter verarbeitet personenbezogene Daten (z. B. IP-Adressen), um die technische Bereitstellung und Sicherheit der Website zu gewährleisten. 
              Es besteht ein Vertrag zur Auftragsverarbeitung gemäß Art. 28 DSGVO.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">4. Erhebung allgemeiner Daten</h2>
            <p>Beim Besuch dieser Website werden automatisch folgende Daten erfasst:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>IP-Adresse</li>
              <li>Browsertyp</li>
              <li>Betriebssystem</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>Referrer-URL</li>
            </ul>
            <p className="mt-4">Diese Daten dienen ausschließlich der technischen Bereitstellung und Sicherheit der Website.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">5. Kontaktformular</h2>
            <p>
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben inklusive der angegebenen Kontaktdaten zur Bearbeitung der Anfrage gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
            <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">6. Bewerbungen</h2>
            <p>
              Wenn Sie uns Bewerbungsunterlagen zusenden, verarbeiten wir Ihre personenbezogenen Daten ausschließlich zum Zweck des Bewerbungsverfahrens.
            </p>
            <p>Dies betrifft insbesondere:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Name</li>
              <li>Kontaktdaten</li>
              <li>Lebenslauf</li>
              <li>Zeugnisse</li>
              <li>Qualifikationen</li>
            </ul>
            <p className="mt-4">
              Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. b DSGVO sowie § 26 BDSG. Sofern keine gesetzliche Aufbewahrungspflicht besteht, werden Bewerbungsunterlagen nach Abschluss des Verfahrens gelöscht.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">7. Cookies</h2>
            <p>Unsere Website verwendet Cookies.</p>
            <p>
              Cookies dienen dazu, unser Angebot nutzerfreundlicher und sicherer zu machen. Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden oder Cookies nur im Einzelfall erlauben.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">8. SSL- bzw. TLS-Verschlüsselung</h2>
            <p>Diese Seite nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">9. Ihre Rechte</h2>
            <p>Sie haben jederzeit das Recht auf:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Auskunft über Ihre gespeicherten Daten</li>
              <li>Berichtigung</li>
              <li>Löschung</li>
              <li>Einschränkung der Verarbeitung</li>
              <li>Datenübertragbarkeit</li>
              <li>Widerruf erteilter Einwilligungen</li>
            </ul>
            <p className="mt-4">Außerdem steht Ihnen ein Beschwerderecht bei einer Datenschutzaufsichtsbehörde zu.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">10. Widerspruch gegen Werbe-E-Mails</h2>
            <p>
              Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter Werbung wird hiermit widersprochen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">11. Google Fonts</h2>
            <p>
              Zur einheitlichen Darstellung von Schriftarten nutzt diese Website Google Fonts. Die Schriftarten sind lokal eingebunden.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">12. Änderungen dieser Datenschutzerklärung</h2>
            <p>Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen.</p>
            <p className="text-sm font-bold mt-4">Stand: Mai 2024</p> {/* Jahr korrigiert auf 2024 (2026 war ein möglicher Tippfehler) */}
          </section>

        </div>
      </div>
    </PageWrapper>
  );
};

export default Datenschutz;